<template>
  <div class="px-4 py-4 space-y-6">
    <div class="flex items-baseline justify-between">
      <h2 class="inline-flex text-xs uppercase font-medium text-gray-600 leading-5">
        {{ label }}
      </h2>

      <div class="inline-flex">
        <label
          class="inline-block px-2 py-1 text-xs leading-5 transition-colors duration-150 uppercase font-medium rounded-l"
          :class="[valueComputed === null ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-900']"
        >
          <input
            type="radio"
            :name="name"
            :value="null"
            v-model="valueComputed"
            class="appearance-none"
          />
          all
        </label>
        <label
          v-for="(filterName, idx) in filters"
          :key="idx"
          class="inline-block px-2 py-1 text-xs leading-5 transition-colors duration-150 uppercase font-medium"
          :class="[
            {
              'rounded-r': filters.length - 1 === idx,
            },
            valueComputed === filterName ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-900',
          ]"
        >
          <input
            type="radio"
            :name="name"
            :value="filterName"
            v-model="valueComputed"
            class="appearance-none"
          />
          {{ allowedFilters[filterName].label }}
        </label>
      </div>
    </div>

    <ul v-if="value && allowedFilters[value].options" class="flex flex-wrap">
      <template v-for="(option, idx) in allowedFilters[value].options">
        <li :key="idx" class="p-1">
          <label
            class="inline-flex p-1 border border-transparent text-sm rounded-full focus-within:ring ring-blue-500 ring-opacity-50 focus-within:border-blue-700"
            :class="[isOptionSelected(option) ? 'bg-blue-600 text-white' : 'bg-gray-200']"
          >
            <input
              v-model="inputValue"
              :type="allowedFilters[value].multiple ? 'checkbox' : 'radio'"
              :value="option.value"
              class="appearance-none opacity-0"
            />
            <div class="flex items-center px-2 space-x-2">
              <span class="inline-flex leading-4">
                {{ option.label }}
              </span>
            </div>
          </label>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'VFilterGroup',
  props: {
    allowedFilters: {
      type: Object,
      required: true,
    },
    filters: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      //
    };
  },
  computed: {
    hasVariations() {
      return Array.isArray(this.variations) && this.variations.length;
    },
    valueComputed: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('update:value', value);
      },
    },
    inputValue: {
      get() {
        return this.allowedFilters[this.value].value;
      },
      set(value) {
        this.$emit('update:filter-value', { key: this.value, value });
      },
    },
  },
  watch: {
    value(key, prevKey) {
      if (!prevKey) {
        return;
      }

      if (this.allowedFilters[prevKey].multiple && this.allowedFilters[prevKey].options) {
        this.$emit('update:filter-value', { key: prevKey, value: [] });
      }
    },
  },
  methods: {
    isOptionSelected(option) {
      if (!this.value) {
        return false;
      }

      if (this.allowedFilters[this.value].multiple) {
        return this.allowedFilters[this.value].value.indexOf(option.value) > -1;
      }

      return this.allowedFilters[this.value].value === option.value;
    },
  },
};
</script>
